import { ApiFragment } from '@digihaven/shared';

import { Series } from '@common/entities/series/series.entity';

export const GetRecordId = (record: Series | ApiFragment) => {
    return record instanceof ApiFragment ? record.getMediaObjectId() : record.Id!;
};

export const GetSeriesId = (record: Series | ApiFragment) => {
    return record instanceof ApiFragment ? record.getVersioningId() : record.Id!;
};
